import {
  faCheck,
  faCircleXmark,
  faDollar,
  faReceipt,
  faStar,
} from '@fortawesome/pro-solid-svg-icons';
import { faTruck, faHouse } from '@fortawesome/pro-light-svg-icons';
import { FallOutlined, RiseOutlined } from '@ant-design/icons';
import logistics from 'data/logisticCarriers.json';
import { DynamicObjectType } from 'types/commons';

export const LOCALES = [
  { value: 'vi', label: 'Tiếng Việt' },
  { value: 'en', label: 'English (US)' },
];

export const USER_ROLES = [
  {
    label: 'ADMIN',
    value: 'ADMIN',
  },
  {
    label: 'USER',
    value: 'USER',
  },
];

export const ORDER_TRACKING_STATUS_CONST = {
  pending: {
    value: 'pending',
    text: 'orderTrackingStatus.pending',
    isDefault: true,
    isRefund: true,
    index: 0,
    isPickup: true,
    color: '#FBBC05',
  },
  approved: {
    value: 'approved',
    text: 'orderTrackingStatus.approved',
    textCod: 'orderTrackingStatus.codApproved',
    isDefault: true,
    isRefund: true,
    index: 1,
    isPickup: true,
    color: '#FBBC05',
  },
  in_progress: {
    value: 'in_progress',
    text: 'orderTrackingStatus.inProgress',
    isDefault: true,
    isRefund: true,
    index: 2,
    color: '#4cb1e8',
  },
  in_shipment: {
    value: 'in_shipment',
    text: 'orderTrackingStatus.inShipment',
    isDefault: true,
    isRefund: true,
    index: 3,
    color: '#4cb1e8',
  },
  delivering: {
    value: 'delivering',
    text: 'orderTrackingStatus.delivering',
    textPickup: 'orderTrackingStatus.readyPickup',
    index: 3,
    color: '#4cb1e8',
  },
  refund_requested: {
    value: 'refund_requested',
    text: 'orderTrackingStatus.refundRequested',
    isRefund: true,
    index: 3,
    color: '#EC5500',
  },
  completed: {
    value: 'completed',
    text: 'orderTrackingStatus.deliveredSuccess',
    textPickup: 'orderTrackingStatus.completed',
    isDefault: true,
    index: 4,
    isPickup: true,
    color: '#74AB00',
  },
  returned: {
    value: 'returned',
    text: 'orderTrackingStatus.completed',
    isRefund: true,
    index: 4,
    color: '#74AB00',
  },
  delivered_fail: {
    value: 'delivered_fail',
    text: 'orderTrackingStatus.deliveredFail',
    index: 4,
    color: '#EC5500',
  },
  cancelled: {
    value: 'cancelled',
    text: 'orderTrackingStatus.cancelled',
    index: 3,
    color: '#EC5500',
  },
};

export const DATA_FIELDS_ORDERS = [
  {
    key: 'createdAt',
    index: 0,
  },
  {
    key: 'fullName',
    index: 1,
  },
  {
    key: 'telephone',
    index: 2,
  },
  {
    key: 'email',
    index: 3,
  },
  {
    key: 'addressLine2',
    index: 4,
  },
  {
    key: 'wardId',
    index: 5,
  },
  {
    key: 'districtId',
    index: 6,
  },
  {
    key: 'provinceId',
    index: 7,
  },
  {
    key: 'paymentType',
    index: 8,
  },
  {
    key: 'orderNumber',
    index: 9,
  },
  {
    key: 'sku',
    index: 10,
  },
  {
    key: 'quantity',
    index: 11,
  },
  {
    key: 'price',
    index: 12,
  },
  {
    key: 'locationId',
    index: 13,
  },
  {
    key: 'paymentStatus',
    index: 14,
  },
  {
    key: 'invoiceInfoAddress',
    index: 15,
  },
  {
    key: 'invoiceInfoBusinessName',
    index: 16,
  },
  {
    key: 'invoiceInfoEmail',
    index: 17,
  },
  {
    key: 'invoiceInfoTaxCode',
    index: 18,
  },
  {
    key: 'invoiceInfoTelephone',
    index: 19,
  },
];

export const ORDER_TYPE_CONST = {
  DELIVERY: {
    value: 'DELIVERY',
    text: 'orderTypes.delivery',
    IconCPN: faTruck,
  },
  CLICKCOLLECT: {
    value: 'CLICKCOLLECT',
    text: 'orderTypes.clickCollect',
    IconCPN: faHouse,
  },
  TAB_TRY_BUY: {
    value: 'TAB_TRY_BUY',
    text: 'orderTypes.tabTryBuy',
    IconCPN: faHouse,
  },
  OFFLINE: {
    value: 'OFFLINE',
    text: 'orderTypes.offline',
    IconCPN: faHouse,
  },
};

export const PAYMENT_TYPE_COD = 'cod';

export const SALE_CHANEL = [
  {
    value: 'facebook',
    text: 'saleChanel.facebook',
  },
  {
    value: 'website',
    text: 'saleChanel.website',
  },
  {
    value: 'instagram',
    text: 'saleChanel.instagram',
  },
  {
    value: 'store',
    text: 'saleChanel.store',
  },
  {
    value: 'other',
    text: 'saleChanel.other',
  },
];

export const SHIPPING_METHOD = [
  {
    key: 'in3Days',
    text: 'shippingFee.in3Days',
    value: -1,
    available: false,
  },
  {
    key: 'in1Day',
    text: 'shippingFee.in1Day',
    value: -1,
    available: false,
  },
  {
    key: 'in2h',
    text: 'shippingFee.in2h',
    value: -1,
    available: false,
  },
];

export const YES_NO_SWITCH = [
  {
    value: true,
    text: 'button.yes',
  },
  {
    value: false,
    text: 'button.no',
  },
];

export const CHANNELS = [
  {
    value: 'website',
    text: 'Website',
    hideFromPromotion: true,
    hasDistributionStock: true,
    stockField: 'stock',
    color: '#94BE55',
    inputColor: '#B4D671',
  },
  {
    value: 'tiktokshops',
    text: 'TikTok',
    hasDistributionStock: true,
    stockField: 'stockTiktok',
    color: '#000000',
    inputColor: '#403e3e',
  },
  {
    value: 'shopee',
    text: 'Shopee',
    hasDistributionStock: true,
    stockField: 'stockShopee',
    color: '#CC6145',
    inputColor: '#D59482',
  },
  {
    value: 'momo_miniapp',
    text: 'MoMo miniapp',
    hideFromPromotion: true,
    isMiniapp: true,
  },
  {
    value: 'lazada',
    text: 'Lazada',
    hasDistributionStock: true,
    stockField: 'stockLazada',
    color: '#10135F',
    inputColor: '#393C7F',
  },
  {
    value: 'tiki',
    text: 'Tiki',
    hasDistributionStock: true,
    stockField: 'stockTiki',
    color: '#6DB3E7',
    inputColor: '#81BCE7',
  },
  {
    value: 'store',
    text: 'Store',
    hasDistributionStock: true,
    stockField: 'stockStore',
    color: '#6852D3',
    inputColor: '#b4a9e9',
  },
];

export const CHANNELS_FILTER = CHANNELS.map((e: DynamicObjectType) => ({
  value: e.value,
  label: e.text,
})).concat([
  {
    value: 'facebook',
    label: 'Facebook',
  },
  {
    value: 'instagram',
    label: 'Instagram',
  },
  {
    value: 'zalo',
    label: 'Zalo',
  },
  {
    value: 'other',
    label: 'ordersReturn.other',
  },
]);

export const MON_TO_FRI_OF_WEEK = {
  valueText: 'mondayToFriday',
  textIsOpen: 'mores.locations.openingHour.openFromMondayToFriday',
};

export const DAYS_EXCEPT_END_WEEK = [
  {
    valueText: 'monday',
    textIsOpen: 'mores.locations.openingHour.openOnMonday',
  },
  {
    valueText: 'tuesday',
    textIsOpen: 'mores.locations.openingHour.openOnTuesday',
  },
  {
    valueText: 'wednesday',
    textIsOpen: 'mores.locations.openingHour.openOnWednesday',
  },
  {
    valueText: 'thursday',
    textIsOpen: 'mores.locations.openingHour.openOnThursday',
  },
  {
    valueText: 'friday',
    textIsOpen: 'mores.locations.openingHour.openOnFriday',
  },
];

export const DAYS_OF_END_WEEK = [
  {
    valueText: 'saturday',
    textIsOpen: 'mores.locations.openingHour.openOnSaturday',
  },
  {
    valueText: 'sunday',
    textIsOpen: 'mores.locations.openingHour.openOnSunday',
  },
];

export const BLOG_STATUS = [
  {
    text: 'Pending',
    value: 'pending',
  },
  {
    text: 'Active',
    value: 'active',
  },
  {
    text: 'Draft',
    value: 'draft',
  },
];

export const ORDER_STATUS_CONST = {
  pending: {
    value: 'pending',
    text: 'orderStatus.pending',
    IconCPN: faReceipt,
    index: 0,
    color: '#FBBC05',
  },
  approved: {
    value: 'approved',
    text: 'orderStatus.approved',
    textCod: 'orderStatus.approvedCod',
    IconCPN: faDollar,
    index: 1,
    color: '#FBBC05',
  },
  in_progress: {
    value: 'in_progress',
    text: 'orderStatus.inProgress',
    IconCPN: faDollar,
    index: 1,
    color: '#FBBC05',
  },
  in_shipment: {
    value: 'in_shipment',
    // text: 'orderStatus.inShipment',
    text: 'orderStatus.delivering',
    textPickup: 'orderStatus.readyPickup',
    IconCPN: faTruck,
    index: 2,
    color: '#FBBC05',
  },
  delivering: {
    value: 'delivering',
    text: 'orderStatus.delivering',
    textPickup: 'orderStatus.readyPickup',
    IconCPN: faTruck,
    index: 2,
    color: '#FBBC05',
  },
  completed: {
    value: 'completed',
    text: 'orderStatus.deliveredSuccess',
    textPickup: 'orderStatus.completed',
    IconCPN: faCheck,
    index: 3,
    color: '#74AB00',
  },
  evaluate: {
    value: 'evaluate',
    text: 'orderStatus.evaluate',
    IconCPN: faStar,
    index: 4,
    color: '#FBBC05',
  },
  delivered_fail: {
    value: 'delivered_fail',
    text: 'orderStatus.deliveredFail',
    IconCPN: faCircleXmark,
    index: 4,
    color: '#EC5500',
  },
  cancelled: {
    value: 'cancelled',
    text: 'orderStatus.cancelled',
    IconCPN: faCircleXmark,
    index: 4,
    color: '#EC5500',
  },
};

export const ORDER_CANCEL_REASONS = [
  {
    value: 'WRONG_PROMOTION',
    text: 'orders.reasons.wrongPromotion',
  },
  {
    value: 'CANCEL_TO_REORDER',
    text: 'orders.reasons.clientCancelToReorder',
  },
  {
    value: 'NO_PAYMENT',
    text: 'orders.reasons.noPayment',
  },
  {
    value: 'CUSTOMER_INTENTION',
    text: 'orders.reasons.customerIntention',
  },
  {
    value: 'STOCK_UNAVAILABLE',
    text: 'orders.reasons.stockUnavailable',
  },
  {
    value: 'OUT_OF_DATE',
    text: 'orders.reasons.dateProduct',
  },
  {
    value: 'LATE_DELIVERY',
    text: 'orders.reasons.lateDelivery',
  },
  {
    value: 'DUPLICATED',
    text: 'orders.reasons.duplicated',
  },
  {
    value: 'CANT_CONTACT',
    text: 'orders.reasons.cantContact',
  },
  {
    value: 'OTHER',
    text: 'orders.reasons.other',
  },
];

export const ORDER_TYPE = [
  {
    value: 'DELIVERY',
    text: 'Delivery',
  },
  {
    value: 'CLICKCOLLECT',
    text: 'Click and collect',
  },
  {
    value: 'TABTRYBY',
    text: 'Keep & Try',
  },
  {
    value: 'OFFLINE',
    text: 'Offline',
  },
];

export const YES_NO_SELECT = [
  {
    value: 0,
    text: 'button.yes',
    valueBool: true,
  },
  {
    value: 1,
    text: 'button.no',
    valueBool: false,
  },
];

export const HIGHLIGHT_TYPES = [
  {
    text: 'websiteConfigs.listingFilterConfig.collections',
    value: 'collections',
  },
  {
    text: 'websiteConfigs.listingFilterConfig.categories',
    value: 'categories',
  },
  {
    text: 'websiteConfigs.listingFilterConfig.recentView',
    value: 'history',
    isUpSizeOnly: true,
  },
];

export const HEADER_MENU_TYPE_CONST = {
  topMenus: {
    text: 'websiteConfigs.headerMenus.top',
    value: '/headerMenus/top',
  },
  // middleMenus: {
  //   text: 'websiteConfigs.headerMenus.middle',
  //   value: '/headerMenus/middle',
  // },
  bottomMenus: {
    text: 'websiteConfigs.headerMenus.bottom',
    value: '/headerMenus/bottom',
  },
};

export const HEADER_MENU_TYPES = Object.values(HEADER_MENU_TYPE_CONST);

export const FOOTER_MENU_TYPE_CONST = {
  // topMenus: {
  //   text: 'footerMenus.top',
  //   value: '/footerMenus/top',
  // },
  middleMenus: {
    text: 'websiteConfigs.footerMenus.middle',
    value: '/footerMenus/middle',
  },
  bottomMenus: {
    text: 'websiteConfigs.footerMenus.bottom',
    value: '/footerMenus/bottom',
  },
};

export const FOOTER_MENU_TYPES = Object.values(FOOTER_MENU_TYPE_CONST);

export const SELLER_ORDER_STATUS_CONST = {
  AWAITING_CONFIRMATION: {
    value: 'AWAITING_CONFIRMATION',
    text: 'orderTrackingStatus.awaitingConfirmation',
    isDefault: true,
    isRefund: true,
    index: 0,
    isPickup: true,
    color: '#FFC53D',
    background: '#FFC53D1A',
  },
  CONFIRMED: {
    value: 'CONFIRMED',
    text: 'orderTrackingStatus.confirmed',
    textCod: 'orderTrackingStatus.confirmed',
    isDefault: true,
    isRefund: true,
    index: 1,
    isPickup: true,
    color: '#6852D3',
    background: '#6852D31A',
  },
  READY_TO_PICK: {
    value: 'READY_TO_PICK',
    text: 'orderTrackingStatus.readyToPick',
    isDefault: true,
    isRefund: true,
    index: 2,
    color: '#6852D3',
    background: '#6852D31A',
  },
  PICKING: {
    value: 'PICKING',
    text: 'orderTrackingStatus.picking',
    isDefault: true,
    isRefund: true,
    index: 3,
    color: '#0075FF',
    background: '#0075FF1A',
  },
  PACKING: {
    value: 'PACKING',
    text: 'orderTrackingStatus.packing',
    textPickup: 'orderTrackingStatus.packing',
    index: 4,
    color: '#0075FF',
    background: '#0075FF1A',
  },
  READY_TO_HANDOVER: {
    value: 'READY_TO_HANDOVER',
    text: 'orderTrackingStatus.readyToHandover',
    isRefund: true,
    index: 5,
    color: '#0075FF',
    background: '#0075FF1A',
  },
  DELIVERING: {
    value: 'DELIVERING',
    text: 'orderTrackingStatus.delivering',
    textPickup: 'orderTrackingStatus.completed',
    isDefault: true,
    index: 6,
    isPickup: true,
    color: '#FA541C',
    background: '#FA541C1A',
  },
  FAILED_DELIVERY: {
    value: 'FAILED_DELIVERY',
    text: 'orderTrackingStatus.failedDelivery',
    isRefund: true,
    index: 7,
    color: '#FA541C',
    background: '#FA541C1A',
  },
  RETURNING: {
    value: 'RETURNING',
    text: 'orderTrackingStatus.returning',
    index: 8,
    color: '#AB2328',
    background: '#AB23281A',
  },
  REJECTED: {
    value: 'REJECTED',
    text: 'orderTrackingStatus.rejected',
    index: 9,
    color: '#AB2328',
    background: '#AB23281A',
  },
  FAIL_QC: {
    value: 'FAIL_QC',
    text: 'orderTrackingStatus.failQC',
    index: 10,
    color: '#AB2328',
    background: '#AB23281A',
  },
  DELIVERY_SUCCESS: {
    value: 'DELIVERY_SUCCESS',
    text: 'orderTrackingStatus.deliverySuccess',
    index: 11,
    color: '#66C11F',
    background: '#66C11F1A',
  },
  CANCELLED: {
    value: 'CANCELLED',
    text: 'orderTrackingStatus.cancelled',
    index: 12,
    color: '#ACACAC',
    background: '#B6B8C133',
  },
  LOST: {
    value: 'LOST',
    text: 'orderTrackingStatus.lost',
    index: 13,
    color: '#FA541C',
    background: '#FA541C1A',
  },
  PENDING_PROCESSING: {
    value: 'PENDING_PROCESSING',
    text: 'orderTrackingStatus.pendingProcessing',
    index: 14,
    color: '#6852D3',
    background: '#6852D31A',
  },
};

export const ENQUIRIES_TOPIC_CONST = {
  FOLLOW: {
    value: 'FOLLOW',
    text: 'enquiries.follow.title',
    items: [
      {
        value: 'EMAIL_SUBSCRIPTION',
        text: 'enquiries.follow.emailSubscription',
      },
    ],
  },
  ORDER: {
    value: 'ORDER',
    text: 'enquiries.order.title',
    items: [
      {
        value: 'ORDER_STATUS',
        text: 'enquiries.order.status',
      },
      {
        value: 'CHANGE_ORDER_INFO',
        text: 'enquiries.order.changeOrderInfo',
      },
      {
        value: 'SHIPPING_FEE',
        text: 'enquiries.order.shippingFee',
      },
    ],
  },
  PAYMENT: {
    value: 'PAYMENT',
    text: 'enquiries.payment.title',
    items: [
      {
        value: 'PAYMENT_METHOD',
        text: 'enquiries.payment.paymentMethod',
      },
      {
        value: 'PAYMENT_FAILURE',
        text: 'enquiries.payment.paymentFailure',
      },
    ],
  },
  REVIEW_SERVICE: {
    value: 'REVIEW_SERVICE',
    text: 'enquiries.reviewService.title',
    items: [
      {
        value: 'REVIEW_GOOD_SERVICE_FOR_STORE',
        text: 'enquiries.reviewService.goodServiceForStore',
      },
      {
        value: 'REVIEW_GOOD_SERVICE_FOR_ONLINE',
        text: 'enquiries.reviewService.goodServiceForOnline',
      },
      {
        value: 'REPORT_SERVICE_FOR_STORE',
        text: 'enquiries.reviewService.reportForStore',
      },
      {
        value: 'REPORT_SERVICE_FOR_ONLINE',
        text: 'enquiries.reviewService.reportForOnline',
      },
    ],
  },
  REVIEW_REPORT: {
    value: 'REVIEW_REPORT',
    text: 'enquiries.reviewReport.title',
    items: [
      {
        value: 'REPORT_INAPPROPRIATE_REVIEW',
        text: 'enquiries.reviewReport.inappropriateReview',
      },
      {
        value: 'REPORT_UNRELIABLE_REVIEW',
        text: 'enquiries.reviewReport.unreliableReview',
      },
    ],
  },
  BUYING_INTENT: {
    value: 'BUYING_INTENT',
    text: 'enquiries.buyingIntent.title',
    items: [
      {
        value: 'OUT_OF_STOCK',
        text: 'enquiries.buyingIntent.outOfStock',
      },
    ],
  },
  OTHER: {
    value: 'OTHER',
    text: 'enquiries.other',
    items: [],
  },
};

export const ENQUIRIES_SUB_TOPIC = Object.values(ENQUIRIES_TOPIC_CONST).reduce(
  (pre, cur) => [...pre, ...(cur.items || [])],
  [],
);

export const ENQUIRIES_STATUS = [
  {
    value: true,
    text: 'enquiries.resolved',
    color: 'blue',
  },
  {
    value: false,
    text: 'enquiries.unresolved',
    color: 'red',
  },
];

export const PROMOTION_TYPES_CONST = {
  shipfee: {
    value: 'shipfee',
    text: 'promotions.promotionTypes.shipfee',
    description: 'promotions.promotionTypes.shipfeeDesc',
  },
  product: {
    value: 'product',
    text: 'promotions.promotionTypes.product',
    description: 'promotions.promotionTypes.productDesc',
  },
  order: {
    value: 'order',
    text: 'promotions.promotionTypes.order',
    description: 'promotions.promotionTypes.orderDesc',
  },
  serial: {
    value: 'serial',
    text: 'promotions.promotionTypes.serial',
    description: 'promotions.promotionTypes.serialDesc',
  },
};

export const PROMOTION_TYPES = Object.values(PROMOTION_TYPES_CONST);

export const PROMOTION_DURATIONS = [
  {
    value: 'comingSoon',
    text: 'promotions.durationType.comingSoon',
  },
  {
    value: 'happening',
    text: 'promotions.durationType.happening',
  },
  {
    value: 'expired',
    text: 'promotions.durationType.expired',
  },
];

export const DISCOUNT_TYPES_CONST = {
  percent: {
    value: 'percent',
    text: 'promotions.discountTypes.percent',
  },
  money: {
    value: 'money',
    text: 'promotions.discountTypes.money',
  },
  gift: {
    value: 'gift',
    text: 'promotions.discountTypes.gift',
  },
  giftOnTop: {
    value: 'giftOnTop',
    text: 'promotions.discountTypes.giftOnTop',
  },
  step: {
    value: 'step',
    text: 'promotions.discountTypes.step',
  },
  fixPrice: {
    value: 'fixPrice',
    text: 'promotions.discountTypes.fixPrice',
  },
  loyaltyPoint: {
    value: 'loyaltyPoint',
    text: 'promotions.discountTypes.loyaltyPoint',
  },
};

export const DISCOUNT_TYPES = Object.values(DISCOUNT_TYPES_CONST);

export const PROMOTION_PRODUCT_TYPES_CONST = {
  productCollections: {
    value: 'productCollection',
    text: 'promotions.productCollections',
  },
  productCategories: {
    value: 'productCategory',
    text: 'promotions.productCategories',
  },
  product: {
    value: 'product',
    text: 'promotions.eachProduct',
  },
};
export const CREATE_FORM = {
  ims: {
    value: 'IMS',
    color: '#6852D3',
  },
  tiktok: {
    value: 'Tiktok',
    color: '#000000',
  },
  lazada: {
    value: 'Lazada',
    color: '#01489C',
  },
  tiki: {
    value: 'Tiki',
    color: '#0075FF',
  },
  shopee: {
    value: 'Shopee',
    color: '#FF730E',
  },
};

export const LABEL_POSITIONS_CONST = {
  topLeft: {
    value: 'topLeft',
    text: 'mores.labels.topLeft',
  },
  topRight: {
    value: 'topRight',
    text: 'mores.labels.topRight',
  },
  bottomLeft: {
    value: 'bottomLeft',
    text: 'mores.labels.bottomLeft',
  },
  bottomRight: {
    value: 'bottomRight',
    text: 'mores.labels.bottomRight',
  },
  bottomCenter: {
    value: 'bottomCenter',
    text: 'mores.labels.bottomCenter',
  },
  full: {
    value: 'full',
    text: 'mores.labels.full',
  },
};

export const LABEL_POSITIONS = Object.values(LABEL_POSITIONS_CONST);
export const LINK_TEMPLATES = {
  products:
    'https://lighto.s3.ap-southeast-1.amazonaws.com/template/Upsert_Product.xlsx',
  productCombos:
    'https://lighto.s3.ap-southeast-1.amazonaws.com/template/Upsert_Combo_Product+.xlsx',
  locations:
    'https://lighto.s3.ap-southeast-1.amazonaws.com/template/Import_Location.xlsx',
  productCategories:
    'https://lighto.s3.ap-southeast-1.amazonaws.com/template/Import_Product_Category.xlsx',
  productCollections:
    'https://lighto.s3.ap-southeast-1.amazonaws.com/template/Import_Product_Collection.xlsx',
  brands:
    'https://lighto.s3.ap-southeast-1.amazonaws.com/template/Import_Product_Brand.xlsx',
  productTypes:
    'https://lighto.s3.ap-southeast-1.amazonaws.com/template/Import_Product_Product+Type.xlsx',
};

export const PRODUCT_BUNDLE_TYPES_CONST = {
  percent: {
    value: 'percent',
    text: 'promotionExternals.percent',
    keyDiscount: 'discountPercent',
  },
  money: {
    value: 'money',
    text: 'promotionExternals.money',
    keyDiscount: 'discountMoney',
  },
  fixPrice: {
    value: 'fixPrice',
    text: 'promotionExternals.fixPrice',
    keyDiscount: 'discountFixPrice',
  },
};

export const PRODUCT_BUNDLE_TYPES = Object.values(PRODUCT_BUNDLE_TYPES_CONST);
export const CONFIG_TYPES = [
  {
    text: 'mores.payment.gift',
    value: 'gift_payment',
  },
  {
    text: 'mores.payment.payment',
    value: 'payment',
  },
];

export const EXCLUSIVE_BY_SHIPPING_METHODS = [
  {
    value: 'delivery',
    text: 'orders.orderTypes.delivery',
  },
  {
    value: 'pickup',
    text: 'orders.orderTypes.clickCollect',
  },
];

export const CANCEL_TO_REASON = [
  {
    value: 'Sai chương trình khuyến mãi, đặt lại',
    label: 'Sai chương trình khuyến mãi, đặt lại',
  },
  {
    value: 'Chuyển khoản lỗi/ Chưa chuyển khoản, đặt lại',
    label: 'Chuyển khoản lỗi/ Chưa chuyển khoản, đặt lại',
  },
  {
    value: 'Chuyển khoản lỗi/ Chưa chuyển khoản, huỷ đơn',
    label: 'Chuyển khoản lỗi/ Chưa chuyển khoản, huỷ đơn',
  },
  {
    value: 'Khách hàng đổi ý',
    label: 'Khách hàng đổi ý',
  },
  {
    value: 'Hết hàng',
    label: 'Hết hàng',
  },
  {
    value: 'Hàng date',
    label: 'Hàng date',
  },
  {
    value: 'Giao hàng chậm',
    label: 'Giao hàng chậm',
  },
  {
    value: 'Đơn trùng',
    label: 'Đơn trùng',
  },
];

export const SUMMARY_CARD_TYPES = [
  {
    value: 'up',
    text: 'summaryCard.up',
    icon: RiseOutlined,
    color: '#4fcea2',
  },
  {
    value: 'down',
    text: 'summaryCard.down',
    icon: FallOutlined,
    color: '#e64c38',
  },
];

export const PAYMENT_STATUS = {
  paid: {
    color: '#88C041',
    text: 'orders.paymentStatuses.paid',
  },
  pending: {
    color: '#FFA940',
    text: 'orders.paymentStatuses.pending',
  },
  fail: {
    color: '#AB2328',
    text: 'orders.paymentStatuses.fail',
  },
  refund: {
    color: '#0075FF',
    text: 'orders.paymentStatuses.refund',
  },
  waiting_for_refund: {
    color: '#E28800',
    text: 'orders.paymentStatuses.waitingForRefund',
  },
  processing_refund: {
    color: '#E28800',
    text: 'orders.paymentStatuses.processingRefund',
  },
  refund_failed: {
    color: '#AB2328',
    text: 'orders.paymentStatuses.refundFailed',
  },
};

export const PAYMENT_STATUSES = [
  {
    value: 'paid',
    text: 'orders.paymentStatuses.paid',
    color: '#27AE60',
  },
  {
    value: 'pending',
    color: '#E28800',
    text: 'orders.paymentStatuses.pending',
  },
  {
    value: 'fail',
    color: '#AB2328',
    text: 'orders.paymentStatuses.fail',
  },
  {
    value: 'refund',
    color: '#0075FF',
    text: 'orders.paymentStatuses.refund',
  },
  {
    value: 'waiting_for_refund',
    color: '#E28800',
    text: 'orders.paymentStatuses.waitingForRefund',
  },
  {
    value: 'processing_refund',
    color: '#E28800',
    text: 'orders.paymentStatuses.processingRefund',
  },
  {
    value: 'refund_failed',
    color: '#AB2328',
    text: 'orders.paymentStatuses.refundFailed',
  },
];

export const PAYMENT_TYPES = [
  {
    value: 'cod',
    text: 'COD',
  },
  {
    value: 'vts',
    text: 'Ví trả sau',
  },
  {
    value: 'vnpay',
    text: 'VnPay',
  },
  {
    value: 'momo',
    text: 'MoMo',
  },
  {
    value: 'fundiin',
    text: 'Fundiin',
  },
  {
    value: 'payoo',
    text: 'Payoo',
  },
  {
    value: 'atome',
    text: 'Atome',
  },
  {
    value: 'kaypay',
    text: 'Kaypay',
  },
  {
    value: 'flik',
    text: 'Flik',
  },
  {
    value: 'aftee',
    text: 'Aftee',
  },
  {
    value: 'zalopay',
    text: 'Zalopay',
  },
];

export const lotDatePattern = /([0-9]{1,})(M|m)\b/;

export const CONDITION_LEVELS = {
  A: {
    value: 'A',
  },
  D1: {
    value: 'D1',
  },
  D2: {
    value: 'D2',
    color: '#EC0000',
  },
  D3: {
    value: 'D3',
    color: '#EC0000',
  },
};

export const ORDER_TYPES = [
  {
    value: 'all',
    text: 'orders.filters.all',
  },
  {
    value: 'in2h',
    text: 'orders.shippingType.in2h',
  },
  {
    value: 'in3Days',
    text: 'orders.shippingType.in3Days',
  },
  {
    value: 'in1Day',
    text: 'orders.shippingType.in1Day',
  },
];

export const LOGISTICS = logistics;

export const TRANSFER_ORDER_STATUS = {
  AWAITING_CONFIRMATION: {
    value: 'AWAITING_CONFIRMATION',
    text: 'transferOrders.transferOrderStatus.awaitingConfirmation',
    color: '#FFB300',
    background: '#FFB3001A',
    textColor: 'text-[#FFB300]',
  },
  CONFIRMED_PICK: {
    value: 'CONFIRMED_PICK',
    text: 'transferOrders.transferOrderStatus.confirmedPick',
    color: '#0075FF',
    background: '#0075FF1A',
    textColor: 'text-[#0075FF]',
  },
  SHIPPING: {
    value: 'SHIPPING',
    text: 'transferOrders.transferOrderStatus.shipping',
    color: '#6852D3',
    background: '#6852D31A',
    textColor: 'text-[#6852D3]',
  },
  RECEIVED: {
    value: 'RECEIVED',
    text: 'transferOrders.transferOrderStatus.received',
    color: '#66C11F',
    background: '#66C11F1A',
    textColor: 'text-[#66C11F]',
  },
  REJECTED: {
    value: 'REJECTED',
    text: 'transferOrders.transferOrderStatus.rejected',
    color: '#AB2328',
    background: '#AB23281A',
    textColor: 'text-[#AB2328]',
  },
  COMPLETED: {
    value: 'COMPLETED',
    text: 'transferOrders.transferOrderStatus.completed',
    color: '#66C11F',
    background: '#66C11F1A',
    textColor: 'text-[#66C11F]',
  },
  CANCELLED: {
    value: 'CANCELLED',
    text: 'transferOrders.transferOrderStatus.cancelled',
    color: '#848484',
    background: '#8484841A',
    textColor: 'text-[#848484]',
  },
};

export const BATCH_STATUS = {
  WAITING_FOR_WS: {
    value: 'WAITING_FOR_WS',
    text: 'batchStatus.waitingForWs',
    color: 'text-[#2F80ED]',
  },
  IN_PROGRESS: {
    value: 'IN_PROGRESS',
    text: 'batchStatus.inProgress',
    color: 'text-[#FFA940]',
  },
  PARTIALLY_COMPLETED: {
    value: 'PARTIALLY_COMPLETED',
    text: 'batchStatus.partiallyCompleted',
    color: 'text-[#2F80ED]',
  },
  COMPLETED: {
    value: 'COMPLETED',
    text: 'batchStatus.completed',
    color: 'text-[#88C041]',
  },
};

export const BAN_REASONS = [
  {
    value: 'Requested by customer',
    text: 'Requested by customer',
  },
  {
    value: 'Reject order more than 3 times',
    text: 'Reject order more than 3 times',
  },
  {
    value: 'Other',
    text: 'Other',
  },
];

export const ACTIVE_STATUS = [
  {
    value: false,
    text: 'Inactive',
    color: 'red',
  },
  {
    value: true,
    text: 'Active',
    color: 'green',
  },
];

export const IS_VOUCHER = [
  {
    value: true,
    label: 'True',
  },
  {
    value: false,
    label: 'False',
  },
];

export const DELIVERY_PARTNER_FILTER = [
  {
    value: 'LEX',
    label: 'LEX',
  },
  {
    value: 'AHAMOVE',
    label: 'Ahamove',
  },
];

export const ORDER_FAILQC_REASONS = [
  {
    value: 'WRONG_PRODUCT',
    text: 'orderDetail.reasons.wrongProduct',
  },
  {
    value: 'BROKEN_PRODUCT',
    text: 'orderDetail.reasons.brokenProduct',
  },
  {
    value: 'NOT_SIMILAR',
    text: 'orderDetail.reasons.notSimilar',
  },
  {
    value: 'USED',
    text: 'orderDetail.reasons.used',
  },
  {
    value: 'UNBOXED',
    text: 'orderDetail.reasons.unboxed',
  },
  {
    value: 'OTHER',
    text: 'orderDetail.reasons.other',
  },
];

export const CHANNELS_TO_FILTER = [
  {
    value: 'facebook',
    label: 'Facebook',
  },
  {
    value: 'instagram',
    label: 'Instagram',
  },
  {
    value: 'tiktokshops',
    label: 'Tiktok',
  },
  {
    value: 'tiki',
    label: 'Tiki',
  },
  {
    value: 'shopee',
    label: 'Shopee',
  },
  {
    value: 'lazada',
    label: 'Lazada',
  },
  {
    value: 'website',
    label: 'Website',
  },
];

export const DELIVERY_TYPES = [
  {
    key: 'INTERNAL',
    text: 'Internal',
  },
  {
    key: 'EXTERNAL',
    text: 'External',
  },
];
